import mock from '../mock'

// ** Third Party Components
import axios from 'axios'

// ** Utils
import { paginateArray } from '../utils'

// ** Utils
import { getUserData } from '@utils'

// ** Custom Components
import GetApiCOC from '../../@fake-db/ApiCOC'

const base64ToString = (response) => { 

  if (response.data.Result === "true" && response.data.response_data.length > 0) {
    return JSON.parse(Buffer.from(response.data.response_data, "base64").toString()) 
  } else {
    return []
  }
}

const getMeetings = async (dataOrigen, refrescar, api, token, body, config) => {

  const configws = {
    method: 'get',
    url:    api,
    headers: { 
      Accept:      'application/json',
      obrientoken: token
    },
    params: body
  }

  let data = dataOrigen

  if (data.meetings.length <= 0 || data.startDate !== config.startDate || data.endDate !== config.endDate || refrescar) {
    const response = await axios(configws)

    if (response.data.Result === 'false') {
      data = { meetings: base64ToString(response) }
    } else {
      data = { meetings: base64ToString(response).data }
    }
  }

  // eslint-disable-next-line object-curly-newline
  const { q = '', perPage = 10, page = 1, sort, sortColumn } = config
  /* eslint-enable */

  const dataAsc = data.meetings.sort((a, b) => {
    if (a[sortColumn]) {
      return a[sortColumn] < b[sortColumn] ? -1 : 1
    } else {
      const splitColumn = sortColumn.split('.')
      const columnA = a[splitColumn[0]][splitColumn[1]]
      const columnB = b[splitColumn[0]][splitColumn[1]]
      return columnA < columnB ? -1 : 1
    }
  })

  const dataToFilter = sort === 'asc' ? dataAsc : dataAsc.reverse()

  const queryLowered = q.toLowerCase()
  const filteredData = dataToFilter.filter(meeting => {

      return (
        (
          (meeting.date ? meeting.date.toLowerCase().includes(queryLowered) : false) ||
          (meeting.user_id ? meeting.user_id.toLowerCase().includes(queryLowered) : false) ||
          (meeting.client_data.email ? meeting.client_data.email.toLowerCase().includes(queryLowered) : false) ||
          (meeting.client_data.name ? meeting.client_data.name.toLowerCase().includes(queryLowered) : false) ||
          (meeting.client_data.phone ? meeting.client_data.phone.toLowerCase().includes(queryLowered) : false) ||
          (meeting.property_data.length > 0 && meeting.property_data[0].internal_key ? meeting.property_data[0].internal_key.toLowerCase().includes(queryLowered) : false) ||
          (meeting.property_data.length > 0 && meeting.property_data[0].name ? meeting.property_data[0].name.toLowerCase().includes(queryLowered) : false) ||
          (meeting.property_data.length > 0 && meeting.property_data[0].address ? meeting.property_data[0].address.toLowerCase().includes(queryLowered) : false) ||
          String(meeting.id_meeting).toLowerCase().includes(queryLowered)
        )
      )
  })

  return [
    200,
    {
      allData: data.meetings,
      total: filteredData.length,
      meetings: filteredData.length <= perPage ? filteredData : paginateArray(filteredData, perPage, page)
    }
  ]  
}

// ------------------------------------------------
// GET: Return list of meetings
// ------------------------------------------------

let dataMeetings = JSON.parse(localStorage.getItem("dataMeeting")) || { meetings: [], startDate: '', endDate: ''}

mock.onGet('/apps/meetings').reply(async config => {
  const user = getUserData()

  let user_id2

  if (user.usercoc.role === 2) {
    user_id2 = user.usercoc.user_id
  } else {
    user_id2 = ""
  }

  let refresh = false

  if (config.reset) {
    refresh = true
  }

  if (config.report) {
    refresh = true

    user_id2 = config.user_id
  }

  const body = {
    page            : 1,
    page_size       : '',
    property_filter : '',
    client_filter   : '',
    date_from       : config.startDate,
    date_to         : config.endDate,
    user_id         : user_id2
  }

  const result = await getMeetings(dataMeetings, refresh, GetApiCOC('getMeetings'), user.token, body, config)

  dataMeetings = { meetings: result[1].allData, startDate: config.startDate, endDate: config.endDate }

  localStorage.setItem("dataMeeting", JSON.stringify(dataMeetings))

  return result
})

